import React, { useContext, useState } from 'react';
import { AsButton, AsCheckbox } from '@adserve/adserve-react-components';
import { ReserveCampaignProperty } from '../../../services/DataService';

export const campaignPackageColumnDefinition = (onQuoteClick, readOnly) => {
    const CustomCheck = (a) => {
        return <AsCheckbox data-id={a.data.id} onChange={onQuoteClick} checked={a.data.quote}></AsCheckbox>;
    };
    return [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'hidden',
            hideInColumnFilter: true
        },
        {
            displayOrder: 4,
            headerName: 'Action',
            field: 'delete',
            type: 'action',
            width: 50,
            hideInColumnFilter: true,
            showInList: true,
            sortable: false
        },

        {
            displayOrder: 4,
            headerName: window.translate('Package Name'),
            field: 'packageName',
            type: 'text',
            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: true,
            sortOrder: '',
            isSticky: true
        },

        {
            displayOrder: 6,
            headerName: window.translate('Number of Weeks'),
            field: 'numWeeks',
            type: 'number',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 7,
            headerName: window.translate('Number of Stations'),
            field: 'numStations',
            type: 'number',
            width: 150,
            showInList: true,
            sortable: false
        },

        {
            displayOrder: 9,
            headerName: window.translate('Book Price'),
            field: 'price',
            type: 'currency',
            width: 'auto',
            showInList: true,
            sortable: false
        }
    ];
};
